export class LogAcessoSistema {
  idLogAcessoSistema: number = null; //Chave primária
  fkSistema: number = null; //Chave estrangeira para os sistemas
  fkServidor: number = null; //Chave estrangeria para os usuários
  dsRecurso: string = null; //
  dhAcesso: Date = null; //

  constructor(d?) {
    if (d) {
      this.idLogAcessoSistema = d.idLogAcessoSistema
        ? d.idLogAcessoSistema
        : null;
      this.fkSistema = d.fkSistema ? d.fkSistema : null;
      this.fkServidor = d.fkServidor ? d.fkServidor : null;
      this.dsRecurso = d.dsRecurso ? d.dsRecurso : null;
      this.dhAcesso = d.dhAcesso ? d.dhAcesso : null;
    }
  }
}
